// Kid sign-in codes. Kids have no email, so a parent mints a short code per kid and the kid
// types just that code once; no two kids share one, so the code alone says who they are. The alphabet drops 0/O, 1/I/L so a code read aloud or
// copied off a parent's phone cannot be mistyped.

export const KID_CODE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";
export const KID_CODE_LENGTH = 6;

export function newKidCode(): string {
  const n = KID_CODE_ALPHABET.length;
  // Largest multiple of n that fits in a byte; bytes above it are dropped so every
  // character is equally likely.
  const limit = Math.floor(256 / n) * n;
  let out = "";
  while (out.length < KID_CODE_LENGTH) {
    const [b] = crypto.getRandomValues(new Uint8Array(1));
    if (b < limit) out += KID_CODE_ALPHABET[b % n];
  }
  return out;
}

/** What a kid typed, made comparable: spaces and dashes dropped, upper-cased. */
export function normaliseKidCode(typed: string): string {
  return typed.replace(/[\s-]/g, "").toUpperCase();
}
